import React from 'react';
import Popover, { PopoverProps } from 'housecall-ui/dist/DesignSystem/DataDisplay/Popover/Popover';
import MenuItem from 'housecall-ui/dist/DesignSystem/Navigation/Menus/MenuItem';
import MenuList from 'housecall-ui/dist/DesignSystem/Navigation/Menus/MenuList';

import { NavTab } from '../types';

type NavPopoverProps = PopoverProps & {
  navItems?: NavTab[];
};

const NavPopover = ({ open, id, anchorEl, onClose, navItems = [], children }: NavPopoverProps) => {
  return (
    <Popover
      data-testid="NavPopover-root"
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      PaperProps={{
        role: 'menu',
        'aria-expanded': open,
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      getContentAnchorEl={null}
    >
      <MenuList>
        {navItems.map(({ label, path }) => (
          <MenuItem version="v2" component="a" tabIndex={0} href={path} key={label}>
            {label}
          </MenuItem>
        ))}
        {children}
      </MenuList>
    </Popover>
  );
};

export default NavPopover;
